/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from 'rxjs';
import {QueryParams} from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: 'root'
})
export class UserResourceService {
  url: string | undefined = undefined;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.url = environmentService.getEnvironmentProperty('usersUrl');
  }

  findAll(query: any, additionalParams?: any): Observable<any> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();

    return this.httpClient.get(`${this.url}${queryString}`);
  }

  assignCurrentUserToCompanyAsSuperUser(legalEntityUuid: string){
    return this.httpClient.post(`${this.url}/assign-to-company-as-super-user/${legalEntityUuid}`, {});
  }

}

